import React, { Component } from 'react'
import { Select, Input } from 'antd'
import _ from 'lodash'

export default class SelectWithOtherOption extends Component {
    constructor(props){
        super(props);

        this.state = {
            otherValue: "",
            value: props.value
        }
        _.bindAll(
            this,
            "onOtherValueChange",
            "onEnter",
            "onChange"
        )
    }
    onEnter(e){
        let {otherValue} = this.state;
        otherValue = _.trim(otherValue);
        e.stopPropagation();
        if(e.keyCode === 13 && otherValue){
            this.setState({
                value: otherValue
            });
            e.target.blur();
        }
    }
    onOtherValueChange(e){
        const otherValue = e.target.value;
        this.setState({
            otherValue
        });
    }
    onChange(value){
        this.setState({
            value
        });
    }
    render() {
        const {otherValue, value} = this.state;
        const {children, ...restProps} = this.props;
        return (
            <Select
                {...restProps}
                onChange={this.onChange}
                dropdownRender={menu => (
                    <>
                        {menu}
                        <div className="p-xs">
                            <Input placeholder="Other" value={otherValue} onChange={this.onOtherValueChange} onKeyDown={this.onEnter} />
                        </div>
                    </>
                )}
                value={value}
            >
                {
                    children
                }
                {/* <Select.Option value="other"><Input /></Select.Option> */}
            </Select>
        )
    }
}
